import type { FC } from 'react';
import { Input, Modal } from 'antd';
import { ImageIcon, X } from 'lucide-react';
import BlogImageEditor from './BlogImageEditor';

interface BlogImagePanelProps {
  effectiveId: string | null;
  featuredImageUrl: string;
  title: string;
  seoKeywords: string[];
  imagePreviewOpen: boolean;
  onFeaturedImageUrlChange: (value: string) => void;
  onImageGenerated: (url: string) => void;
  onImagePreviewClose: () => void;
}

const BlogImagePanel: FC<BlogImagePanelProps> = ({
  effectiveId,
  featuredImageUrl,
  title,
  seoKeywords,
  imagePreviewOpen,
  onFeaturedImageUrlChange,
  onImageGenerated,
  onImagePreviewClose,
}) => (
  <>
    {effectiveId ? (
      <BlogImageEditor
        articleId={effectiveId}
        currentImageUrl={featuredImageUrl || null}
        articleTitle={title}
        seoKeywords={seoKeywords}
        onImageGenerated={onImageGenerated}
      />
    ) : (
      <div className="space-y-2 rounded-lg border border-slate-200 p-3 dark:border-slate-600">
        <p className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-slate-500">
          <ImageIcon className="h-3.5 w-3.5" /> Image à la une
        </p>
        <Input value={featuredImageUrl} onChange={(e) => onFeaturedImageUrlChange(e.target.value)} placeholder="https://... (URL de l'image)" />
        <p className="text-[10px] text-slate-400">Sauvegardez d&apos;abord l&apos;article pour accéder à la génération IA d&apos;image</p>
      </div>
    )}

    {/* Image preview modal */}
    <Modal
      open={imagePreviewOpen}
      onCancel={onImagePreviewClose}
      footer={null}
      width="80vw"
      centered
      closeIcon={<X className="h-5 w-5" />}
      styles={{ body: { padding: 0 } }}
    >
      {featuredImageUrl && <img src={featuredImageUrl} alt="Preview" className="w-full rounded-lg" />}
    </Modal>
  </>
);

export default BlogImagePanel;
